<template>
  <div class="austrian-post-guide">
    <h1>Add pass to wallet</h1>
    <div>
      <p>
        As soon as you have opened the Wallet app, please press "Add".
      </p>
    </div>
    <div class="center-img">
      <img src="../assets/img/guide.png" alt="how to add pass" width="240" />
    </div>

    <Button label="Next" v-on:click="next" />
  </div>
</template>

<script>
import Button from "@/components/Button.vue";

export default {
  components: {
    Button
  },
  methods: {
    next() {
      this.$router.push(`/ios/success/2/${this.$route.params.id}`);
    }
  }
};
</script>
<style scoped>
.center-img {
  margin: 40px auto;
  text-align: center;
}
</style>
